import { render, staticRenderFns } from "./tipsEdit.vue?vue&type=template&id=70da2196"
import script from "./tipsEdit.vue?vue&type=script&lang=js"
export * from "./tipsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports